import { useMemo } from 'react'
import type {
    MainProductCart,
    Product as SuggestedSetProduct
} from '@components/common/SuggestedSet'

type UseSuggestedSetMainProductParams = {
    product: any
    variant: any
    description: any
    shortDescription: any
    variantPriceRange: any
    productPriceRange: any
    effectivePpum?: number
    effectiveIsSet?: number
}

export function useSuggestedSetMainProduct({
    product,
    variant,
    description,
    shortDescription,
    variantPriceRange,
    productPriceRange,
    effectivePpum,
    effectiveIsSet
}: UseSuggestedSetMainProductParams): {
    isSuggestedSet: boolean
    mainProductForSet?: SuggestedSetProduct
    mainProductCartForSet?: MainProductCart
} {
    return useMemo(() => {
        const isSuggestedSet = (product?.related_products?.length ?? 0) > 0
        if (!isSuggestedSet || !product || !variant) {
            return { isSuggestedSet: false }
        }

        const variantThumb = (variant as { thumbnail?: { url?: string } })
            ?.thumbnail?.url
        const productThumb = (product as { small_image?: { url?: string } })
            ?.small_image?.url
        const thumbUrl = variantThumb || productThumb || ''

        const variantGallery = (
            variant as { media_gallery?: SuggestedSetProduct['media_gallery'] }
        )?.media_gallery
        const productGallery = (
            product as { media_gallery?: SuggestedSetProduct['media_gallery'] }
        )?.media_gallery
        const mediaGallery = variantGallery ?? productGallery ?? []

        const mainProductForSet = {
            id: product.id,
            name: product.name,
            url_key: product.url_key ?? '',
            small_image: { url: thumbUrl },
            price_range: variantPriceRange ?? productPriceRange ?? {},
            sku: variant.sku,
            media_gallery: mediaGallery,
            description: description ?? { html: '' },
            short_description: shortDescription ?? { html: '' },
            medidas_y_materialidad:
                (product as { medidas_y_materialidad?: string })
                    ?.medidas_y_materialidad ?? '',
            ppum: effectivePpum ?? 0,
            is_set: effectiveIsSet ?? 0
        } as unknown as SuggestedSetProduct

        const mainProductCartForSet = {
            sku: variant.sku,
            uid: (variant as { uid: string }).uid,
            ...(variant.sku !== product?.sku
                ? { parent_sku: product?.sku ?? '' }
                : {})
        }

        return {
            isSuggestedSet: true,
            mainProductForSet,
            mainProductCartForSet
        }
    }, [
        product,
        variant,
        description,
        shortDescription,
        variantPriceRange,
        productPriceRange,
        effectivePpum,
        effectiveIsSet
    ])
}
